import { UI_COM_SITE_CONFIG } from "context/SiteSettingsContext/constants";

const {
  getImageOptimizerUrlByEnv,
  getOptimizedImageUrl: getOptimizedImageUrlCore,
} = await import("@ubnt/store.core/lib/utils/imageOptimizer.mjs");

const imageOptimizerUrl =
  getImageOptimizerUrlByEnv(__CONFIG__.BUILD_ENV) ?? undefined;

const OPTIMIZE_DEFAULT_QUALITY = 75;

/**
 * Creates build env specific full asset url
 * Falls back to pathname if unable to resolve
 */
export const absoluteAssetUrl = (
  pathname: string,
  queryParams?: Record<string, string>,
): string => {
  try {
    if (__CONFIG__.BUILD_ENV === "local") {
      return pathname;
    }

    const url = new URL(UI_COM_SITE_CONFIG.defaultRegion.baseUrl);
    url.pathname = pathname;

    Object.entries(queryParams ?? {}).forEach(([key, value]) => {
      if (value) {
        url.searchParams.append(key, value);
      }
    });

    return url.toString();
  } catch {
    // Fallback to pathname
    return pathname;
  }
};

/**
 * Convert an image url to an optimized url if enabled
 *
 * @param {string} src
 * @param {number} width
 * @param {number} quality
 * @returns {string}
 */
export const getOptimizedImageUrl = (
  src,
  width,
  quality = OPTIMIZE_DEFAULT_QUALITY,
) =>
  getOptimizedImageUrlCore(imageOptimizerUrl)({
    src,
    width,
    quality,
  });

/**
 * Helper that calls `getImageOptimiserUrl` on each src item
 *
 * @param {string[]} srcList
 * @param {number} width
 * @param {number} quality
 * @returns {string[]}
 */
export const getOptimizedImageUrls = (
  srcList,
  width,
  quality = OPTIMIZE_DEFAULT_QUALITY,
) => {
  return srcList.map((src) => {
    return getOptimizedImageUrl(src, width, quality);
  });
};

export const getOptimizedImage = (path: string, size: number) =>
  getOptimizedImageUrl(absoluteAssetUrl(path), size);
